import styled, { css } from 'styled-components';
import Button from '~/components/form-elements/button';
import { color, spacing, media, Heading2 } from '~/theme';
import { rem } from '~/theme/variables/typography';

export const AlertContainer = styled.div<{
    $alertType: 'error' | 'success' | 'warning' | 'informational';
}>`
    border-width: 0 0 0 0.25rem;
    border-style: solid;
    padding: ${spacing.spacing5};
    margin: ${spacing.spacing5} ${spacing.spacing0} ${spacing.spacing0};
    position: relative;
    width: 100%;
    max-width: ${rem(928)} !important;

    ${props =>
        props.$alertType === 'error' &&
        css`
            max-width: ${rem(732)};
            background: ${color.calloutErrorBG};
            border-color: ${color.calloutErrorBorder};

            & a {
                color: ${color.calloutErrorLink};

                &:hover,
                &:focus {
                    color: ${color.calloutErrorLinkHover};
                }

                &:active {
                    color: ${color.calloutErrorLinkActive};
                }

                &:visited {
                    color: ${color.calloutErrorLink};
                }
            }
        `};

    ${props =>
        props.$alertType === 'success' &&
        css`
            background: ${color.calloutSuccessBG};
            border-color: ${color.calloutSuccessBorder};
        `};

    ${props =>
        props.$alertType === 'warning' &&
        css`
            background: ${color.calloutWarningBG};
            border-color: ${color.calloutWarningBorder};
        `};

    ${props =>
        props.$alertType === 'informational' &&
        css`
            background: ${color.calloutInformationBG};
            border-color: ${color.calloutInformationBorder};
        `}
`;

export const AlertHeadingContainer = styled.div<{ $dismissible?: boolean }>`
    display: flex;
    align-items: center;
    margin: ${props =>
        props.$dismissible
            ? `${spacing.spacing0} ${spacing.spacing8} ${spacing.spacing4} ${spacing.spacing0}`
            : `${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing0}`};
`;

export const AlertBodyContainer = styled.div`
    display: flex;
`;

export const AlertHeadingIcon = styled.div`
    display: inline-block;
    vertical-align: top;
    margin-right: calc(${spacing.spacing4} * 0.95);

    & svg {
        width: 32px;
        height: 32px;
    }

    @media ${media.small} {
        & svg {
            width: 36px;
            height: 36px;
        }
    }
`;

export const AlertHeading = styled(Heading2)`
    // padding-top: calc(${spacing.spacing1} * 0.5);
    margin: ${spacing.spacing0};
`;

export const AlertBody = styled.div`
    margin-left: ${spacing.spacing0};

    @media ${media.small} {
        margin-left: calc(${spacing.spacing8} + ${spacing.spacing1});
    }

    & p {
        margin-top: ${spacing.spacing0};

        &:last-of-type {
            margin-bottom: ${spacing.spacing2};
        }

        &:last-of-type + ul {
            margin-top: ${spacing.spacing4};
        }
    }

    & ul {
        list-style-type: disc;
        margin-left: calc(${spacing.spacing4} + ${spacing.spacing1});
        padding: ${spacing.spacing0};

        li {
            padding-bottom: ${spacing.spacing3};

            &:last-child {
                padding-bottom: ${spacing.spacing0};
            }
        }

        &:last-of-type {
            margin-bottom: ${spacing.spacing3};
        }
    }
`;

export const DismissButton = styled(Button).attrs({
    appearance: 'tertiary',
})`
    font-size: 2rem;
    line-height: 1;
    padding: 0;
    position: absolute;
    top: 22px;
    right: 16px;
    min-width: ${spacing.spacing6};
    width: auto;
    margin: ${spacing.spacing0};
`;

export default {
    AlertContainer,
    AlertHeadingContainer,
    AlertHeadingIcon,
    AlertBody,
    DismissButton,
};
